import * as React from "react";
import { styled, useTheme, Theme, CSSObject, alpha } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import PostAddIcon from "@mui/icons-material/PostAdd";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import { useStyles } from "../../theme/appStyles";
import {
  Avatar,
  Collapse,
  Grid,
  InputAdornment,
  ListItemButton,
  TextField,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UserImg from "../../Images/user_login_photo.webp";
import { useState } from "react";
import Notification from "../../Components/Popup/notification";
import LogoMain from "../../Images/logo_main_black.webp";

import { MdOutlineNotificationsNone } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import Profile from "../../Components/Popup/profile";
import { appColors } from "../../theme/appcolors";
import { useLocation, useNavigate, Link } from "react-router-dom";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import CategoryIcon from "@mui/icons-material/Category";
import PeopleIcon from "@mui/icons-material/People";
import LoopIcon from "@mui/icons-material/Loop";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import GolfCourseIcon from "@mui/icons-material/GolfCourse";
import StyleIcon from "@mui/icons-material/Style";
import FlagIcon from "@mui/icons-material/Flag";
import PrintIcon from "@mui/icons-material/Print";
import PaidIcon from "@mui/icons-material/Paid";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import StoreIcon from "@mui/icons-material/Store";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import SettingsIcon from "@mui/icons-material/Settings";
import DescriptionIcon from "@mui/icons-material/Description";
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import SettingsApplicationsSharpIcon from '@mui/icons-material/SettingsApplicationsSharp';
import GroupsIcon from '@mui/icons-material/Groups';
import axios from 'axios';
import { useAppDispatch, useAppSelector } from "../../Store/hooks";
import { setCurrentUser } from "../../Store/Auth/AuthSlice";
import { selectCurrentUser } from "../../Store/Auth/AuthSelector";
import EventIcon from "@mui/icons-material/Event";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports'
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import TvIcon from '@mui/icons-material/Tv';
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import DevicesIcon from '@mui/icons-material/Devices';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import HistoryIcon from '@mui/icons-material/History';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

const drawerWidth = 280;
const headerHeight = 100;
interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}



const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  height: headerHeight,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    paddingLeft: 0,
  }),
  ...(!open && {
    marginLeft: 0,
    width: "100%",
    paddingLeft: "75px",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0px",
    },
  }),
}));

const IsNotMobileDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      // Explicit white — overrides theme.palette.background.paper
      // (which is dark in dark mode) so the area below the menu
      // never bleeds dark navy through.
      background: "#FFFFFF",
      backgroundColor: "#FFFFFF",
      borderRight: "1px solid #e2e8f0",
      boxShadow: "2px 0 8px rgba(0,0,0,0.04)",
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      background: "#FFFFFF",
      backgroundColor: "#FFFFFF",
      borderRight: "1px solid #e2e8f0",
      boxShadow: "2px 0 8px rgba(0,0,0,0.04)",
    },
  }),
}));

const MobileDrawer = styled(MuiDrawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  "& .MuiDrawer-paper": {
    width: drawerWidth,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "#FFFFFF",
    backgroundColor: "#FFFFFF",
  },
}));

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: headerHeight,
  padding: theme.spacing(0, 1),
  backgroundColor: "#FFFFFF",
  borderBottom: "1px solid #EEF2F7",
  margin: "0px",
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  flexShrink: 0,
}));

// Sidebar footer — VM Display branding pinned to the bottom of the drawer.
// Sits as a flex sibling of DrawerContent (which has flexGrow:1) so it
// always anchors at the bottom regardless of menu length.
const DrawerFooter = styled("div")({
  flexShrink: 0,
  padding: "12px 16px",
  borderTop: "1px solid #EEF2F7",
  backgroundColor: "#FFFFFF",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 2,
  fontSize: 11,
  color: "#94A3B8",
  letterSpacing: "0.04em",
  userSelect: "none",
});

const DrawerContent = styled("div")(({ theme }) => ({
  background: "#FFFFFF",
  backgroundColor: "#FFFFFF",
  color: "#4B5563",
  borderRight: "1px solid #E9EEF5",
  overflowY: "auto", // Enable vertical scrolling
  overflowX: "hidden", // Disable horizontal scrolling
  flexGrow: 1,
  // Flexbox gotcha: a flex child with overflow:auto needs minHeight:0
  // or it'll never shrink below its content's natural height, leaving
  // a gap that exposes the parent Paper's background underneath.
  minHeight: 0,

 scrollbarWidth: "none", // Firefox
  "-ms-overflow-style": "none", // IE/Edge

  "&::-webkit-scrollbar": {
    display: "none", // Chrome, Safari, Edge
  },




  // "&::-webkit-scrollbar": {
  //   width: "0px", // Initially hidden
  // },
  // "&:hover::-webkit-scrollbar": {
  //   width: "4px", // Show scrollbar on hover
  // },
  // "&::-webkit-scrollbar-thumb": {
  //   backgroundColor:
  //     appColors.dataBssThemeDarkMenuColorLight["--bs-main-nav-item-color"],
  //   borderRadius: "10px",
  // },
  // "&::-webkit-scrollbar-thumb:hover": {
  //   backgroundColor: "rgba(0, 0, 0, 0.5)",
  // },
  // "&::-webkit-scrollbar-track": {
  //   background: "transparent",
  // },
}));

const PaddingBody = styled("div")(({ theme }) => ({
  height: headerHeight,
}));

type SubmenuItem = {
  topBarTitle?: string;
  title: string;
  path: string;
  newPage?: boolean;
  icon: React.ReactElement;
};

type menuList = {
  topBarTitle: string;
  title: string;
  icon: React.ReactElement;
  path: string;
  newPage?: boolean;
  submenuOpen?: boolean;
  submenus?: SubmenuItem[];
};

const MainMenuList: {
  comomTitle: string;
  menuList?: menuList[];
}[] = [
  {
    comomTitle: "General",
    menuList: [
      {
        title: "Dashboard",
        topBarTitle: "Welcome!",
        icon: <MenuIcon />,
        path: "/dashboard",
        submenuOpen: false,
      }, 
      {
        title: "Onboard Company",
        topBarTitle: "Onboard Company",
        icon: <RocketLaunchIcon />,
        path: "/onboarding/new-client",
        submenuOpen: false,
      },    
      {
        title: "Display Modules",
        topBarTitle: "Display Modules",
        icon: <DevicesIcon />,
        path: "#devices",
        submenuOpen: true,
        submenus: [
          {
            title: "Devices",
            topBarTitle: "Device List",
            icon: <TvIcon />,
            path: "/device/list",
          },
          {
            title: "Playlist Groups",
            topBarTitle: "Playlist Groups",
            icon: <PlaylistPlayIcon />,
            path: "/playlist-groups/list",
          },
          {
            title: "Playlists",
            topBarTitle: "Playlist List",
            icon: <PlaylistPlayIcon />,
            path: "/playlist/list",
          },
          {
            title: "Menu Schedules",
            topBarTitle: "Menu Schedules",
            icon: <EventIcon />,
            path: "/menu-schedules/list",
          },
          {
            title: "Templates",
            topBarTitle: "Layout Templates",
            icon: <PlaylistPlayIcon />,
            path: "/templates/list",
          },
          {
            title: "Media Library",
            topBarTitle: "Media Library",
            icon: <PermMediaIcon />,
            path: "/media/library",
          },
        ],
      },
      {
        title: "Monitoring",
        topBarTitle: "Device Monitoring",
        icon: <MonitorHeartIcon />,
        path: "#monitoring",
        submenuOpen: true,
        submenus: [
          {
            title: "Device Monitoring",
            topBarTitle: "Device Monitoring",
            icon: <DesktopWindowsIcon />,
            path: "/monitoring/devices",
          },
          {
            title: "Pilot Status",
            topBarTitle: "Pilot Status",
            icon: <RocketLaunchIcon />,
            path: "/pilot/status",
          },
          {
            title: "Activity Logs",
            topBarTitle: "Activity Logs",
            icon: <HistoryIcon />,
            path: "/signage-activity",
          },
        ],
      },
      {
        title: "Billing",
        topBarTitle: "Device Billing",
        icon: <ReceiptLongIcon />,
        path: "/billing/devices",
        submenuOpen: false,
      },
      {
        title: "App Updates",
        topBarTitle: "App Releases",
        icon: <SystemUpdateAltIcon />,
        path: "/app-updates",
        submenuOpen: false,
      },
    ],
  },
  {
    comomTitle: "Users",
    menuList: [
      {
        title: "Company",
        topBarTitle: "Company List",
        icon: <StoreIcon />,
        path: "/company/list",
        submenuOpen: false,
      },
      {
        title: "User",
        topBarTitle: "User List",
        icon: <GroupsIcon />,
        path: "/signage-users",
        submenuOpen: false,
      },
    ],
  },
  {
    comomTitle: "Setting",
    menuList: [
      {
        title: "Setting",
        topBarTitle: "Setting",
        icon: <SettingsApplicationsSharpIcon />,
        path: "#settings",
        submenuOpen: true,
        submenus: [
          {
            topBarTitle: "Installation Guide",
            title: "Installation Guide",
            icon: <PeopleIcon />,
            path: "/installation-guide",
          },
          {
            topBarTitle: "System Health",
            title: "System Health",
            icon: <PeopleIcon />,
            path: "/system/health",
          },
          {
            topBarTitle: "Production Checklist",
            title: "Checklist",
            icon: <PeopleIcon />,
            path: "/system/checklist",
          },
          {
            topBarTitle: "Pilot QA Checklist",
            title: "Pilot QA",
            icon: <PeopleIcon />,
            path: "/system/pilot-checklist",
          },
          {
            topBarTitle: "Server Logs",
            title: "Logs",
            icon: <PeopleIcon />,
            path: "/system/logs",
          },
          {
            topBarTitle: "Backup Reference",
            title: "Backup",
            icon: <PeopleIcon />,
            path: "/system/backup",
          },
          {
            topBarTitle: "Email Template List",
            title: "Email Templates",
            icon: <PeopleIcon />,
            path: "/email/list",
          },
          {
            topBarTitle: "Note Template List",
            title: "Note Templates",
            icon: <PeopleIcon />,
            path: "/note/list",
          },
        ],
      },
    ],
  },
];

// ---------------------------------------------------------------------------
// Sidebar active-route resolution
// ---------------------------------------------------------------------------
// Active state is DERIVED FROM THE URL, never from click-set state, so it can
// never go stale after navigation (back/forward, direct entry, refresh).
//
// Matching is route-aware and anchored on the *resource root* (the first path
// segment) so a resource's list / create / edit / detail routes all activate
// the same item:
//   /playlist-groups/list, /playlist-groups/create, /playlist-groups/edit/5,
//   /playlist-groups/12          → root "/playlist-groups"
// Matching respects segment boundaries, so "/playlist" never matches
// "/playlist-groups" (the character after "/playlist" is "-", not "/").
//
// Exactly ONE item wins: the FIRST menu item (in declared order) whose resource
// root matches. This makes aliased/duplicate paths deterministic — the
// "Menu Schedules" item shares the "/playlist-groups" root with "Playlist
// Groups" (menu schedules are edited on the playlist group), so Playlist Groups
// (declared first) is the single active item instead of both lighting up.
const normalizePath = (p: string): string =>
  p.length > 1 && p.endsWith("/") ? p.replace(/\/+$/, "") : p;

const resourceRoot = (path: string): string => {
  const seg = path.replace(/^\/+/, "").split("/")[0];
  return "/" + seg;
};

const isUnderRoot = (pathname: string, root: string): boolean => {
  const L = normalizePath(pathname);
  return L === root || L.startsWith(root + "/");
};

type ActiveMenu =
  | { type: "top"; menuTitle: string }
  | { type: "sub"; menuTitle: string; index: number }
  | null;

const resolveActiveMenu = (
  sections: { comomTitle: string; menuList?: menuList[] }[],
  pathname: string
): ActiveMenu => {
  for (const section of sections) {
    for (const menu of section.menuList || []) {
      if (menu.submenus && menu.submenus.length > 0) {
        for (let i = 0; i < menu.submenus.length; i++) {
          if (isUnderRoot(pathname, resourceRoot(menu.submenus[i].path))) {
            return { type: "sub", menuTitle: menu.title, index: i };
          }
        }
      } else if (menu.path && !menu.path.startsWith("#")) {
        if (isUnderRoot(pathname, resourceRoot(menu.path))) {
          return { type: "top", menuTitle: menu.title };
        }
      }
    }
  }
  return null;
};

export default function MiniDrawer({
  children,
}: {
  children: React.ReactNode;
}) {
  const theme = useTheme();
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileDrawerOpen, setMobileDrawerOpen] = React.useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(true);
  const isSalesRoute = location.pathname.startsWith('/sales');
  const isScanRoute = location.pathname.startsWith('/scan');
  const isPortalRoute =
    location.pathname.includes('/restaurant-portal/') ||
    location.pathname === '/restaurant-portal/login' ||
    location.pathname === '/player' ||
    location.pathname.startsWith('/player/') ||
    location.pathname === '/p' ||
    location.pathname.startsWith('/p/') ||
    location.pathname.startsWith('/installer') ||
    location.pathname.startsWith('/download/') ||
    /\/devices\/\d+\/print-sheet/.test(location.pathname);

  const [notificationPopUp, setNotificationPopUp] =
    React.useState<HTMLElement | null>(null);
  const [profilePopUp, setProfilePopUp] = useState<HTMLElement | null>(null);
  const openProfilePopUp = Boolean(profilePopUp);
  const openNotificationPopUp = Boolean(notificationPopUp);

  const [currentMenuName, setCurrentMenuName] = React.useState("");
  const [hoveredMenuName, setHoveredMenuName] = React.useState("");
  const [expandMenu, setExpandMenu] = React.useState<string>("");
  const [topBarTitle, setTopBarTitle] = useState("");
  const [hoveredSubmenu, setHoveredSubmenu] = React.useState("");
  const [selectedSubmenu, setSelectedSubmenu] = React.useState("");

  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(selectCurrentUser);
  // Synthesise a UserInfo-shaped view so existing JSX doesn't have to change.
  // `role` MUST stay the raw enum (super_admin / company_admin / content_manager)
  // because filteredMainMenuList below switches on it. Display label goes
  // through `roleLabel` and is rendered separately in the topbar.
  const userInfo = currentUser
    ? {
        id: currentUser.id,
        username: currentUser.username,
        token: localStorage.getItem("token") || "",
        user_id: currentUser.id,
        role: currentUser.role,
        roleLabel: currentUser.role_label || currentUser.role,
      }
    : null;
  const API_URL = process.env.REACT_APP_API_URL;

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentMenuName]);

  // React.useEffect(() => {
  //   for (const mainMenu of MainMenuList) {
  //     for (const menu of mainMenu.menuList || []) {
  //       if (menu.path === location.pathname) {
  //         setCurrentMenuName(menu.path);
  //         setSelectedSubmenu("");
  //         setExpandMenu(menu.title);
  //       }

  //       for (const submenu of menu.submenus || []) {
  //         if (submenu.path === location.pathname) {
  //           setSelectedSubmenu(submenu.path);
  //           setExpandMenu(menu.title);
  //         }
  //       }
  //     }
  //   }
  // }, [location.pathname]);


  React.useEffect(() => {
    const findTopBarTitle = (): string => {
      // Check custom routes first
      if (location.pathname.startsWith("/customer-history/")) {
        return "Customer Details";
      }
      if (location.pathname.startsWith("/product-history/")) {
        return "Product Details";
      }
      if (location.pathname.startsWith("/company-history/")) {
        return "Company Details & Edit";
      }
      if (location.pathname.startsWith("/quote-history/")) {
        return "Work Order Edit";
      }
      if (location.pathname.startsWith("/work-order/history/")) {
        return "Work Order Details";
      }
      if (location.pathname.startsWith("/invoice/history/")) {
        return "Invoice Details";
      }
      if (location.pathname.startsWith("/team-history/")) {
        return "Team Details";
      }
      if (location.pathname.startsWith("/customer-history/project/")) {
        return "Customer's Project Details";
      }

      if (location.pathname.startsWith("/menu-schedules/create")) {
        return "Create Menu Schedule";
      }
      if (/^\/menu-schedules\/\d+/.test(location.pathname)) {
        return "Menu Schedule";
      }

      if (location.pathname.startsWith("/looping/create")) {
        return "Create Looping";
      }
      if (location.pathname.startsWith("/department/create")) {
        return "Create Department";
      }
      if (location.pathname.startsWith("/coursing/create")) {
        return "Create Coursing";
      }
      if (location.pathname.startsWith("/brand/create")) {
        return "Create Product Brand";
      }
      if (location.pathname.startsWith("/tag/create")) {
        return "Create Product Tag";
      }
      if (location.pathname.startsWith("/tax/create")) {
        return "Create Tax";
      }
      if (location.pathname.startsWith("/printer/create")) {
        return "Create Printer";
      }
      if (location.pathname.startsWith("/customer/create")) {
        return "Create Customer";
      }
      if (location.pathname.startsWith("/email/create")) {
        return "Create Email Template";
      }
      if (location.pathname.startsWith("/note/create")) {
        return "Create Note Template";
      }
      // if (location.pathname.startsWith("/expense/")) {
      //   return "Edit Expense";
      // }
     
   
   

      // Check MainMenuList for matching path
      for (const mainMenu of MainMenuList) {
        for (const menu of mainMenu.menuList || []) {
          if (menu.path === location.pathname) {
            return menu.topBarTitle;
          }

          for (const submenu of menu.submenus || []) {
            if (submenu.path === location.pathname) {
              return submenu.topBarTitle || "WELCOME!";
            }
          }
        }
      }

      // Default title if no matches are found
      // return "WELCOME!";
      return "";
    };

    setTopBarTitle(findTopBarTitle());
  }, [location.pathname]);

  
  React.useEffect(() => {
    if (isPortalRoute) return;
    const fetchUserInfo = async () => {
      try {
        const response = await axios.post(
          `${API_URL}/user/userInfo`,
          {},
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
            },
          }
        );
        // Backend returns presentUser() shape merged with {token}.
        // Push into Redux so every page can read role/company without refetching.
        const data = response.data?.data;
        if (data) {
          const { token, ...userOnly } = data;
          dispatch(setCurrentUser(userOnly));
        }
      } catch (error) {
        console.error('Error fetching user info', error);
      }
    };

    fetchUserInfo();
  }, [isPortalRoute, dispatch, API_URL]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerToggle = () => {
    setOpen(!open);
    setExpandMenu("");
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleMobileDrawerToggle = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  const handleMobileDrawerClose = () => {
    setMobileDrawerOpen(false);
  };

  const handleClickNotificationPopUp = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setNotificationPopUp(event.currentTarget);
  };

  const handleClickProfilePopUp = (event: React.MouseEvent<HTMLElement>) => {
    setProfilePopUp(event.currentTarget);
  };

  const handleCloseProfilePopUp = () => {
    setProfilePopUp(null);
  };

  const handleCloseNotificationPopUp = () => {
    setNotificationPopUp(null);
  };

  const handleImgClick = () => {
    navigate("/dashboard");
  };

  const handleMainMenuItemClick = (ml: menuList) => {
    if (ml.submenus && ml.submenus.length > 0) {
      setExpandMenu(ml.title === expandMenu ? "" : ml.title);
    } else if (ml.path) {
      setCurrentMenuName(ml.path);
      setSelectedSubmenu("");
      navigate(ml.path);
      setMobileDrawerOpen(false);
    }
    setTopBarTitle(ml.topBarTitle || "WELCOME!");
  };

  const handleSubmenuItemClicked = (submenu: SubmenuItem) => {
    setCurrentMenuName(submenu.path);
    setSelectedSubmenu(submenu.path);
    navigate(submenu.path);
    setTopBarTitle(submenu.topBarTitle || "WELCOME!");
    setMobileDrawerOpen(false);
  };

  const filteredMainMenuList = React.useMemo(() => {
    if (!userInfo?.role) return MainMenuList;
    const role = userInfo.role;

    // Super admin sees everything.
    if (role === "super_admin" || role === "Admin") return MainMenuList;

    // Company admin manages their tenant: all sections except platform Settings.
    if (role === "company_admin" || role === "Manager") {
      return MainMenuList
        .map((section) =>
          section.comomTitle === "Setting" ? null : section
        )
        .filter(
          (section): section is { comomTitle: string; menuList: menuList[] } =>
            section !== null
        );
    }

    // Content manager: General section only (Dashboard + Devices submenu
    // which contains Playlists and Media Library). No Users, no Settings.
    // These items previously lived under the Users section, so content
    // managers were never authorised to see them. They are now grouped under
    // General for everyone else, so strip them back out here to preserve the
    // exact set of pages a content manager could reach before the restructure.
    if (role === "content_manager") {
      const hiddenPaths = new Set([
        "/pilot/status",
        "/signage-activity",
        "/billing/devices",
        "/app-updates",
      ]);
      return MainMenuList
        .map((section) => {
          if (section.comomTitle !== "General") return null;
          const menus = (section.menuList || [])
            .map((menu) => {
              if (hiddenPaths.has(menu.path)) return null;
              if (menu.submenus && menu.submenus.length > 0) {
                const submenus = menu.submenus.filter(
                  (sub) => !hiddenPaths.has(sub.path)
                );
                // Drop the parent group if it has no reachable children left.
                if (submenus.length === 0) return null;
                return { ...menu, submenus };
              }
              return menu;
            })
            .filter((menu): menu is menuList => menu !== null);
          return { ...section, menuList: menus };
        })
        .filter(
          (section): section is { comomTitle: string; menuList: menuList[] } =>
            section !== null
        );
    }

    // Unknown role: dashboard only.
    return MainMenuList
      .map((section) => {
        const filteredMenus = section.menuList?.filter(
          (menu) => menu.title === "Dashboard"
        );
        return filteredMenus && filteredMenus.length > 0
          ? { ...section, menuList: filteredMenus }
          : null;
      })
      .filter(
        (section): section is { comomTitle: string; menuList: menuList[] } =>
          section !== null
      );
  }, [userInfo]);

  // Single source of truth for which sidebar item is active — derived purely
  // from the URL against the *rendered* (role-filtered) menu, so indices align
  // with what's on screen and exactly one item can be active at a time.
  const activeMenu = React.useMemo(
    () => resolveActiveMenu(filteredMainMenuList, location.pathname),
    [filteredMainMenuList, location.pathname]
  );

  // Keep the legacy selection state (still read by the mobile drawer) and the
  // parent-expansion state in sync with the URL-derived active item. Expansion
  // is auto-opened for the active parent but remains a separate concern from
  // selection — a user can still collapse a group manually and it only re-opens
  // on the next navigation.
  React.useEffect(() => {
    const flatMenus = filteredMainMenuList.flatMap((s) => s.menuList || []);
    if (activeMenu?.type === "sub") {
      const menu = flatMenus.find((m) => m.title === activeMenu.menuTitle);
      const sub = menu?.submenus?.[activeMenu.index];
      setExpandMenu(activeMenu.menuTitle);
      setSelectedSubmenu(sub?.path || "");
      setCurrentMenuName(sub?.path || "");
      setHoveredSubmenu(sub?.path || "");
    } else if (activeMenu?.type === "top") {
      const menu = flatMenus.find((m) => m.title === activeMenu.menuTitle);
      setCurrentMenuName(menu?.path || "");
      setSelectedSubmenu("");
    } else {
      setCurrentMenuName("");
      setSelectedSubmenu("");
    }
  }, [activeMenu, filteredMainMenuList]);


  // Portal pages render full-screen without any admin chrome
  if (isPortalRoute) {
    return <>{children}</>;
  }

  if (!userInfo) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex" }}>
      {!isMobile ? (
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          <AppBar position="fixed" open={open} 
           className={isSalesRoute || isScanRoute ? classes.SalesTopbar : classes.topbar}
            style={{ width: "100%", marginLeft: 0 }} >
          {(isSalesRoute || isScanRoute)  && (
    <img
      src={LogoMain}
      alt="AttoDesk Logo"
      style={{
        position: "absolute",
        left: "40px", // adjust as needed
        top: "50%",
        transform: "translateY(-50%)",
        height: "40px", // or whatever fits your AppBar
        cursor: "pointer",
      }}
      onClick={handleImgClick}
    />
  )}
            <Toolbar className={classes.toolbar}>
              <Typography width={"100%"} className={classes.h4}>
                {topBarTitle}
              </Typography>

            
              <Grid
                container
                data-testid="user-content"
                spacing={1}
                alignItems="center"
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >

<Grid item>
                  <Link to="/dashboard" style={{ textDecoration: 'none' }}>
                    <Typography variant="h6" sx={{ cursor: 'pointer', color: 'primary.main' }}>
                      Admin
                    </Typography>
                  </Link>
                </Grid>
                <Grid item>
               
                  <IconButton
                    onClick={handleClickNotificationPopUp}
                    className={classes.topbarButton}
                    aria-haspopup="true"
                  >
                    <MdOutlineNotificationsNone
                      className={classes.topbarIcon}
                    />
                  </IconButton>
                  <IconButton
                    onClick={handleClickProfilePopUp}
                    className={classes.topbarButton}
                    aria-haspopup="true"
                  >
                    <Avatar
                      alt="Travis Howard"
                      src={UserImg}
                      className={classes.topbarIconProfile}
                    />
                  </IconButton>
                 
                </Grid>

               

                <Grid item>
                  <div className={classes.appSearch}>
                    {/* <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControl,
                          notchedOutline: classes.notchedOutline,
                        },
                      }}
                      fullWidth
                      placeholder="Search .."
                      variant="outlined"
                      size="small"
                    /> */}

<Typography width={"100%"} className={classes.h5}>
                {userInfo?.username}
              </Typography>
                <span style={{ fontSize: "0.8rem", color: "#888" }}>
      {userInfo?.roleLabel}{currentUser?.company?.name ? ` · ${currentUser.company.name}` : ""}
    </span>
                  </div>
                </Grid>
              </Grid>
             

              <Profile
                profile={profilePopUp}
                onClose={handleCloseProfilePopUp}
                open={openProfilePopUp}
              />
              <Notification
                notification={notificationPopUp}
                onClose={handleCloseNotificationPopUp}
                open={openNotificationPopUp}
              />
            </Toolbar>
          </AppBar>
          {(!isSalesRoute && !isScanRoute) && (
          <IsNotMobileDrawer variant="permanent" open={open}>
            <DrawerHeader>
              {open ? (
                <Box onClick={handleImgClick}
                  sx={{
                    display: "flex", alignItems: "center", gap: 1,
                    flex: 1, minWidth: 0, cursor: "pointer", pl: 1,
                  }}>
                  <img
                    src={LogoMain}
                    alt="VM display"
                    style={{
                      height: 44,
                      width: 44,
                      objectFit: "contain",
                      display: "block",
                      flexShrink: 0,
                    }}
                  />
                  <Box sx={{ minWidth: 0, lineHeight: 1.1 }}>
                    <Typography sx={{
                      fontSize: 15, fontWeight: 800, color: "#0F172A",
                      letterSpacing: "-0.01em", whiteSpace: "nowrap",
                      overflow: "hidden", textOverflow: "ellipsis",
                    }}>
                      VM display
                    </Typography>
                    <Typography sx={{
                      fontSize: 9.5, fontWeight: 600, color: "#94A3B8",
                      letterSpacing: "0.05em", textTransform: "uppercase",
                      whiteSpace: "nowrap",
                    }}>
                      Smart Display System
                    </Typography>
                  </Box>
                </Box>
              ) : (
                <Box onClick={handleImgClick} sx={{ cursor: "pointer", display: "flex", justifyContent: "center", flex: 1 }}>
                  <img
                    src={LogoMain}
                    alt="VM display"
                    style={{ height: 36, width: 36, objectFit: "contain", display: "block" }}
                  />
                </Box>
              )}

              <IconButton
                className={classes.topbarButton}
                onClick={handleDrawerToggle}
              >
                {open ? (
                  <ChevronRightIcon className={classes.topbarIcon} />
                ) : (
                  <ChevronLeftIcon className={classes.topbarIcon} />
                )}
              </IconButton>
            </DrawerHeader>

            <DrawerContent>
              {filteredMainMenuList.map((ml, index) => (
                <React.Fragment key={index}>
                  <Box>
                    {open && (
                      <Typography className={classes.menuTitle}>
                        {ml.comomTitle}
                      </Typography>
                    )}
                  </Box>
                  {ml.menuList && (
                    <List>
                      {ml.menuList.map((menuList) => {
                        // Active state is derived from the URL (activeMenu), so
                        // exactly one item is ever active — no stale click state.
                        const isActive =
                          activeMenu?.type === "top" &&
                          activeMenu.menuTitle === menuList.title;
                        // "Child active" = this parent owns the active submenu.
                        const childActive =
                          activeMenu?.type === "sub" &&
                          activeMenu.menuTitle === menuList.title;
                        return (
                        <ListItem
                          button
                          key={menuList.title}
                          disablePadding
                          sx={{
                            display: "block",
                          }}
                          onMouseEnter={() => setHoveredMenuName(menuList.path)}
                          onMouseLeave={() => setHoveredMenuName("")}
                        >
                          <ListItemButton
                           component={Link}  to={menuList.path}
                            onClick={() => handleMainMenuItemClick(menuList)}
                            sx={(() => {
                              return {
                                position: "relative",
                                mx: 1,
                                my: 0.25,
                                pl: isActive ? "12px" : "16px",
                                borderRadius: "10px",
                                transition: "all 0.2s ease",
                                background: isActive
                                  ? "linear-gradient(90deg, #FFF7D6 0%, #FFFDF5 100%)"
                                  : childActive
                                  ? "rgba(224,177,0,0.08)"
                                  : "transparent",
                                boxShadow: isActive
                                  ? "inset 0 0 0 1px rgba(224,177,0,0.15), 0 4px 12px rgba(224,177,0,0.10)"
                                  : "none",
                                "&::before": isActive
                                  ? {
                                      content: '""',
                                      position: "absolute",
                                      left: 0, top: 6, bottom: 6,
                                      width: 4,
                                      borderRadius: 2,
                                      bgcolor: "#E0B100",
                                    }
                                  : undefined,
                                "&:hover": {
                                  background: isActive
                                    ? "linear-gradient(90deg, #FFF7D6 0%, #FFFDF5 100%)"
                                    : childActive
                                    ? "rgba(224,177,0,0.12)"
                                    : "#F8FAFC",
                                  transition: "all 0.2s ease",
                                  "& .MuiListItemIcon-root, & .MuiTypography-root": {
                                    color: isActive ? "#0F172A" : "#0F172A",
                                    transition: "all 0.2s ease",
                                  },
                                },
                                "& .MuiListItemIcon-root": {
                                  color: isActive
                                    ? "#D4A017"
                                    : childActive
                                    ? "#D4A017"
                                    : hoveredMenuName === menuList.path
                                    ? "#0F172A"
                                    : "#64748B",
                                  opacity: 1,
                                  transition: "all 0.2s ease",
                                },
                                "& .MuiTypography-root": {
                                  color: isActive
                                    ? "#0F172A"
                                    : childActive
                                    ? "#0F172A"
                                    : hoveredMenuName === menuList.path
                                    ? "#0F172A"
                                    : "#4B5563",
                                  fontWeight: isActive ? 700 : childActive ? 600 : 500,
                                  opacity: 1,
                                  transition: "all 0.2s ease",
                                },
                                borderLeft: "none",
                              };
                            })()}
                          >
                            <ListItemIcon
                              className={classes.listItemIcomMainMenu}
                            >
                              {menuList.icon as React.ReactNode}
                            </ListItemIcon>
                            <ListItemText>{menuList.title}</ListItemText>
                            <ListItemIcon
                              className={classes.listItemIcomMainMenu}
                              sx={{
                                display: "flex",
                                textAlign: "end",
                                justifyContent: "flex-end",
                              }}
                            >
                              {menuList.submenus &&
                                (expandMenu === menuList.title ? (
                                  <ExpandLessIcon
                                    sx={{
                                      fontSize: "18px",
                                      display: "flex",
                                      textAlign: "end",
                                      justifyContent: "flex-end",
                                      "&:hover": { color: "#0F172A" },
                                      color:
                                        hoveredMenuName === menuList.path
                                          ? "#0F172A"
                                          : "#94A3B8",
                                      opacity: 1,
                                      transition: "all 0.2s ease",
                                    }}
                                  />
                                ) : (
                                  <ExpandMoreIcon
                                    sx={{
                                      fontSize: "18px",
                                      display: "flex",
                                      textAlign: "end",
                                      justifyContent: "flex-end",
                                      "&:hover": { color: "#0F172A" },
                                      color:
                                        hoveredMenuName === menuList.path
                                          ? "#0F172A"
                                          : "#94A3B8",
                                      opacity: 1,
                                      transition: "all 0.2s ease",
                                    }}
                                  />
                                ))}
                            </ListItemIcon>
                          </ListItemButton>
                          {menuList.submenus && (
                            <Collapse
                              in={expandMenu === menuList.title}
                              timeout="auto"
                              unmountOnExit
                            >
                              <List sx={{ bgcolor: "#FAFBFD", borderRadius: "10px", mx: 1.25, mb: 0.5, py: 0.5 }}>
                                {menuList.submenus.map((submenu, subIndex) => {
                                  // Match by parent + index (never by path) so
                                  // aliased paths can't activate two items.
                                  const subActive =
                                    activeMenu?.type === "sub" &&
                                    activeMenu.menuTitle === menuList.title &&
                                    activeMenu.index === subIndex;
                                  return (
                                  <ListItem
                                    disablePadding
                                    key={submenu.title}
                                    onMouseEnter={() => setHoveredSubmenu(submenu.path)}
                                    onMouseLeave={() => setHoveredSubmenu("")}
                                  >
                                    <ListItemButton
                                      component={Link} to={submenu.path}
                                      onClick={() => handleSubmenuItemClicked(submenu)}
                                      sx={{
                                        position: "relative",
                                        pl: subActive ? "56px" : "60px",
                                        py: 0.65,
                                        mx: 0.75,
                                        my: 0.15,
                                        borderRadius: "8px",
                                        transition: "all 0.2s ease",
                                        background: subActive
                                          ? "linear-gradient(90deg, #FFF7D6 0%, #FFFDF5 100%)"
                                          : "transparent",
                                        boxShadow: subActive ? "inset 0 0 0 1px rgba(224,177,0,0.15)" : "none",
                                        "&::before": subActive
                                          ? {
                                              content: '""',
                                              position: "absolute",
                                              left: 4, top: 6, bottom: 6,
                                              width: 4, borderRadius: 2,
                                              bgcolor: "#E0B100",
                                            }
                                          : undefined,
                                        "&:hover": {
                                          background: subActive
                                            ? "linear-gradient(90deg, #FFF7D6 0%, #FFFDF5 100%)"
                                            : "#F8FAFC",
                                          "& .MuiTypography-root": { color: "#0F172A" },
                                        },
                                        "& .MuiTypography-root": {
                                          color: subActive ? "#0F172A" : hoveredSubmenu === submenu.path ? "#0F172A" : "#64748B",
                                          fontWeight: subActive ? 700 : 500,
                                          fontSize: 13,
                                          opacity: 1,
                                          transition: "all 0.2s ease",
                                        },
                                      }}
                                    >
                                      <ListItemText>
                                        <Typography>{submenu.title}</Typography>
                                      </ListItemText>
                                    </ListItemButton>
                                  </ListItem>
                                  );
                                })}
                              </List>
                            </Collapse>
                          )}
                        </ListItem>
                        );
                      })}
                    </List>
                  )}
                </React.Fragment>
              ))}
            </DrawerContent>
            <DrawerFooter>
              <Box sx={{ fontWeight: 700, color: "#0B1E2D", fontSize: 12 }}>VM Display</Box>
              <Box>v1.0.0</Box>
            </DrawerFooter>
          </IsNotMobileDrawer>
          )}
        </Box>
      ) : (
        <Box sx={{ display: "flex" }}>
          <AppBar position="fixed" className={classes.mobileTopbar}>
            <Toolbar className={classes.toolbar}>
              <Grid
                container
                justifyContent="space-between"
                sx={{ width: "100%" }}
                alignItems="center"
              >
                <Grid item md={1} sm={1}>
                  <IconButton
                    onClick={handleMobileDrawerToggle}
                    edge="start"
                    sx={{
                      ...(mobileDrawerOpen && { display: "none" }),
                    }}
                    className={classes.topbarButton}
                  >
                    {mobileDrawerOpen ? (
                      <CloseIcon className={classes.topbarIcon} />
                    ) : (
                      <MenuIcon className={classes.topbarIcon} />
                    )}
                  </IconButton>
                </Grid>
                <Grid item md={2} sm={2}>
                  <Typography width={"100%"} className={classes.h4}>
                    {topBarTitle}
                  </Typography>
                </Grid>
                <Grid item md={9} sm={9} justifyContent="end" alignItems="end">
                  <Grid
                    container
                    spacing={1}
                    alignItems="end"
                    justifyContent="flex-end"
                    sx={{
                      display: "flex",
                    }}
                  >
                    <Grid item>
                      <IconButton
                        onClick={handleClickNotificationPopUp}
                        className={classes.topbarButton}
                        aria-haspopup="true"
                      >
                        <MdOutlineNotificationsNone
                          className={classes.topbarIcon}
                        />
                      </IconButton>
                      <IconButton
                        onClick={handleClickProfilePopUp}
                        className={classes.topbarButton}
                        aria-haspopup="true"
                      >
                        <Avatar
                          alt="Travis Howard"
                          src={UserImg}
                          className={classes.topbarIconProfile}
                        />
                      </IconButton>
                    </Grid>

                      <Box mb={0.5}>
            <Typography
        className={classes.h5}
              sx={{ fontWeight: 500,color: "text.secondary", lineHeight: 1.1 }}
              noWrap
            >
              {userInfo?.username}
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", fontSize: "0.75rem" }}
              noWrap
            >
              {userInfo?.roleLabel}{currentUser?.company?.name ? ` · ${currentUser.company.name}` : ""}
            </Typography>
          </Box>

                    <Grid
                      item
                      sx={{
                        [theme.breakpoints.down("sm")]: {
                          display: "none",
                        },
                      }}
                    >
                      <div className={classes.appSearch}>
                        <TextField
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CiSearch
                                  className={classes.searchWidgetIcon}
                                />
                              </InputAdornment>
                            ),
                            classes: {
                              root: classes.formControl,
                              notchedOutline: classes.notchedOutline,
                            },
                          }}
                          fullWidth
                          placeholder="Search .."
                          variant="outlined"
                          size="small"
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Profile
                profile={profilePopUp}
                onClose={handleCloseProfilePopUp}
                open={openProfilePopUp}
              />
              <Notification
                notification={notificationPopUp}
                onClose={handleCloseNotificationPopUp}
                open={openNotificationPopUp}
              />
            </Toolbar>

            <>
              <MobileDrawer
                open={mobileDrawerOpen}
                onClose={handleMobileDrawerClose}
               
              >
                <DrawerHeader>
                  {open && (
                    <Box onClick={handleImgClick}
                      sx={{
                        display: "flex", alignItems: "center", gap: 1,
                        flex: 1, minWidth: 0, cursor: "pointer", pl: 1,
                      }}>
                      <img
                        src={LogoMain}
                        alt="VM display"
                        style={{
                          height: 44, width: 44,
                          objectFit: "contain", display: "block", flexShrink: 0,
                        }}
                      />
                      <Box sx={{ minWidth: 0, lineHeight: 1.1 }}>
                        <Typography sx={{
                          fontSize: 15, fontWeight: 800, color: "#0F172A",
                          letterSpacing: "-0.01em", whiteSpace: "nowrap",
                          overflow: "hidden", textOverflow: "ellipsis",
                        }}>
                          VM display
                        </Typography>
                        <Typography sx={{
                          fontSize: 9.5, fontWeight: 600, color: "#94A3B8",
                          letterSpacing: "0.05em", textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}>
                          Smart Display System
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  <IconButton
                    className={classes.topbarButton}
                    onClick={handleMobileDrawerClose}
                  >
                    {theme.direction === "rtl" ? (
                      <ChevronRightIcon className={classes.topbarIcon} />
                    ) : (
                      <ChevronLeftIcon className={classes.topbarIcon} />
                    )}
                  </IconButton>
                </DrawerHeader>
                <DrawerContent>
                  {filteredMainMenuList.map((ml, index) => (
                    <React.Fragment key={index}>
                      <Box>
                        {open && (
                          <Typography className={classes.menuTitle}>
                            {ml.comomTitle}
                          </Typography>
                        )}
                      </Box>
                      {ml.menuList && (
                        <List>
                          {ml.menuList.map((menuList) => (
                            <ListItem
                              button
                              key={menuList.title}
                              disablePadding
                              sx={{
                                display: "block",
                              }}
                              onMouseEnter={() =>
                                setHoveredMenuName(menuList.path)
                              }
                              onMouseLeave={() => setHoveredMenuName("")}
                            >
                              <ListItemButton
                                component={Link}  to={menuList.path}
                                onClick={() =>
                                  handleMainMenuItemClick(menuList)
                                }
                                sx={{
                                  transition: "none",
                                  "&:hover": {
                                    transition: "none",
                                    "& .MuiListItemIcon-root, & .MuiTypography-root":
                                      {
                                        color:
                                          theme.palette.mainMenuNav
                                            .hoverColorNavBg,
                                        transition: "none",
                                      },
                                  },
                                  "& .MuiListItemIcon-root": {
                                    color:
                                      selectedSubmenu?.startsWith(
                                        menuList.path
                                      ) ||
                                      hoveredMenuName === menuList.path ||
                                      currentMenuName === menuList.path
                                        ? theme.palette.secondary.main
                                        : currentMenuName === menuList.path
                                        ? theme.palette.mainMenuNav
                                            .hoverColorNavBg
                                        : theme.palette.mainMenuNav
                                            .hoverColorNavBg,
                                    opacity:
                                      selectedSubmenu?.startsWith(
                                        menuList.path
                                      ) ||
                                      hoveredMenuName === menuList.path ||
                                      currentMenuName === menuList.path
                                        ? 1
                                        : 0.6,
                                    transition: "none",
                                  },
                                  "& .MuiTypography-root": {
                                    color:
                                      selectedSubmenu?.startsWith(
                                        menuList.path
                                      ) ||
                                      hoveredMenuName === menuList.path ||
                                      currentMenuName === menuList.path
                                        ? theme.palette.mainMenuNav
                                            .hoverColorNavBg
                                        : currentMenuName === menuList.path
                                        ? theme.palette.mainMenuNav
                                            .hoverColorNavBg
                                        : theme.palette.mainMenuNav
                                            .hoverColorNavBg,
                                    opacity:
                                      selectedSubmenu?.startsWith(
                                        menuList.path
                                      ) ||
                                      hoveredMenuName === menuList.path ||
                                      currentMenuName === menuList.path
                                        ? 1
                                        : 0.6,
                                    transition: "none",
                                  },
                                  borderLeft:
                                    selectedSubmenu?.startsWith(
                                      menuList.path
                                    ) || currentMenuName === menuList.path
                                      ? `3px solid ${theme.palette.secondary.main}`
                                      : currentMenuName === menuList.path
                                      ? "none"
                                      : "none",
                                }}
                              >
                                <ListItemIcon
                                  className={classes.listItemIcomMainMenu}
                                >
                                  {menuList.icon as React.ReactNode}
                                </ListItemIcon>
                                <ListItemText>{menuList.title}</ListItemText>
                                <ListItemIcon
                                  className={classes.listItemIcomMainMenu}
                                  sx={{
                                    display: "flex",
                                    textAlign: "end",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  {menuList.submenus &&
                                    (expandMenu === menuList.title ? (
                                      <ExpandLessIcon
                                        sx={{
                                          fontSize: "18px",
                                          display: "flex",
                                          textAlign: "end",
                                          justifyContent: "flex-end",
                                          "&:hover": {
                                            color:
                                              theme.palette.mainMenuNav
                                                .hoverColorNavBg,
                                          },
                                          color:
                                            selectedSubmenu?.startsWith(
                                              menuList.path
                                            ) ||
                                            hoveredMenuName === menuList.path ||
                                            currentMenuName === menuList.path
                                              ? theme.palette.mainMenuNav
                                                  .hoverColorNavBg
                                              : currentMenuName ===
                                                menuList.path
                                              ? theme.palette.mainMenuNav
                                                  .hoverColorNavBg
                                              : theme.palette.mainMenuNav
                                                  .hoverColorNavBg,
                                          opacity:
                                            selectedSubmenu?.startsWith(
                                              menuList.path
                                            ) ||
                                            hoveredMenuName === menuList.path ||
                                            currentMenuName === menuList.path
                                              ? 1
                                              : 0.6,
                                        }}
                                      />
                                    ) : (
                                      <ExpandMoreIcon
                                        sx={{
                                          fontSize: "18px",
                                          display: "flex",
                                          textAlign: "end",
                                          justifyContent: "flex-end",
                                          "&:hover": {
                                            color:
                                              theme.palette.mainMenuNav
                                                .hoverColorNavBg,
                                          },
                                          color:
                                            selectedSubmenu?.startsWith(
                                              menuList.path
                                            ) ||
                                            hoveredMenuName === menuList.path ||
                                            currentMenuName === menuList.path
                                              ? theme.palette.mainMenuNav
                                                  .hoverColorNavBg
                                              : currentMenuName ===
                                                menuList.path
                                              ? theme.palette.mainMenuNav
                                                  .hoverColorNavBg
                                              : theme.palette.mainMenuNav
                                                  .hoverColorNavBg,
                                          opacity:
                                            selectedSubmenu?.startsWith(
                                              menuList.path
                                            ) ||
                                            hoveredMenuName === menuList.path ||
                                            currentMenuName === menuList.path
                                              ? 1
                                              : 0.6,
                                        }}
                                      />
                                    ))}
                                </ListItemIcon>
                              </ListItemButton>
                              {menuList.submenus && (
                                <Collapse
                                  in={expandMenu === menuList.title}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <List>
                                    {menuList.submenus.map((submenu) => (
                                      <ListItem
                                        disablePadding
                                        key={submenu.title}
                                        onMouseEnter={() =>
                                          setHoveredSubmenu(submenu.path)
                                        }
                                        onMouseLeave={() =>
                                          setHoveredSubmenu("")
                                        }
                                      >
                                        <ListItemButton
                                          component={Link} to={submenu.path}
                                          onClick={() =>
                                            handleSubmenuItemClicked(submenu)
                                          }
                                          sx={{
                                            pl: "72px",
                                            "&:hover": {
                                              "& .MuiListItemIcon-root, & .MuiTypography-root":
                                                {
                                                  color:
                                                    theme.palette.mainMenuNav
                                                      .hoverColorNavBg,
                                                },
                                            },
                                            "& .MuiTypography-root": {
                                              color:
                                                hoveredSubmenu ===
                                                  submenu.path ||
                                                currentMenuName === submenu.path
                                                  ? theme.palette.mainMenuNav
                                                      .hoverColorNavBg
                                                  : theme.palette.mainMenuNav
                                                      .hoverColorNavBg,
                                              opacity:
                                                hoveredSubmenu ===
                                                  submenu.path ||
                                                currentMenuName === submenu.path
                                                  ? 1
                                                  : 0.6,
                                            },
                                          }}
                                        >
                                          <ListItemText>
                                            <Typography>
                                              {submenu.title}
                                            </Typography>
                                          </ListItemText>
                                        </ListItemButton>
                                      </ListItem>
                                    ))}
                                  </List>
                                </Collapse>
                              )}
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </React.Fragment>
                  ))}
                </DrawerContent>
                <DrawerFooter>
                  <Box sx={{ fontWeight: 700, color: "#0B1E2D", fontSize: 12 }}>VM Display</Box>
                  <Box>v1.0.0</Box>
                </DrawerFooter>
              </MobileDrawer>
            </>
          </AppBar>
        </Box>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: open ? `calc(100% - ${drawerWidth}px)` : "100%",
        }}
      >
        <PaddingBody />
        {children}
      </Box>
    </Box>
  );
}
